import { userState } from "./types";

const initinalState: userState = {
	rights: [],
	isLoggedIn: false,
	user: null,
	avatarSrc: null
};

export {
	initinalState,
};